<div class="unsaved-changes-warning">
  <div class="unsaved-changes-warning__body">
    <div class="unsaved-changes-warning__notice">
      There are unsaved changes. Are you sure you want to cancel?
    </div>
    <div class="unsaved-changes-warning__notice">
      If you cancel, the last saved version of the source schain file will
      continue to be used.
    </div>
  </div>

  <div class="unsaved-changes-warning__footer">
    <button
      nz-button
      type="button"
      nzType="primary"
      class="unsaved-changes-warning__btn limit-warning__btn--submit"
      (click)="onSubmit()"
    >
      Yes, Cancel
    </button>
    <button
      nz-button
      type="button"
      nzType="default"
      class="unsaved-changes-warning__btn limit-warning__btn--cancel"
      (click)="onCancel()"
    >
      Go Back
    </button>
  </div>
</div>
